import React, { useContext, useState } from "react";
import style from "./joinFamily.module.css";
import { DashboardContext } from "../../../../context/DashboardContext";
import axios from "axios";
import client from "../../../../api/client";
import { AuthContext } from "../../../../context/AuthContext";
import { useEffect } from "react";
import moment from "moment";

const JoinFamily = () => {
  const { user } = useContext(AuthContext);
  const [showRelatives, setShowRelatives] = useState(false);
  const [userData, setUserData] = useState({});
  const [editingId, setEditingId] = useState(null);
  const [editingRelation, setEditingRelation] = useState("");
  const [newRelative, setNewRelative] = useState({
    name: "",
    relation: "",
    gender: "",
    dob: "",
    ma: "",
    address: "",
    pin: "",
    phone: "",
  });

  console.log(user, "user in join family");

  const getUserDetails = async () => {
    try {
      const res = await client.get(`/get-user-details`, {
        params: {
          icsid: user.icsid,
          phone: user.mobile,
          mode: 'DETAILED_WITH_DONATIONS'
        }
      });
      const data = res.data?.data?.[0];
      if (data) {
        console.log("User details fetched successfully", data);
        setUserData(data);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    getUserDetails();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewRelative((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddRelative = async () => {
    if (!newRelative.name || !newRelative.relation) return;
    console.log(newRelative, "new relative to be added");
    const res = await client.get(`/add-relative`, {
      params: {
        lname: newRelative.name,
        iname: newRelative.name,
        gender: newRelative.gender || 'Male',
        mobileNo: newRelative.phone,
        email: "",
        panNo: '',
        dob: newRelative.dob ? moment(newRelative.dob, "YYYY-MM-DD").format('DD-MM-YYYY') : '',
        ma:newRelative.ma ? moment(newRelative.ma, "YYYY-MM-DD").format('DD-MM-YYYY') : '',
        address: newRelative.address,
        address2: '',
        address3: '',
        city: '',
        state: '',
        country: '',
        pincode: newRelative.pin,
        category: 'FAMILY',
        type: "",
        strictdq: 'no',
      }
    });
    console.log(res, "response from add relative");
    const data = res.data
    if (data) {
      console.log("User details fetched successfully", data);

      const addRelativeWithUserData = await client.get(`/add-relative-with-user`, {
        params: {
          "individual1ICSId": data.icsid,
          "individual2ICSId": user.icsid,
          relationName: newRelative.relation,
          relationCategory: 'FAMILY',
          oper: 'add'
        }
      });

      console.log(addRelativeWithUserData, "response from add relative with user");
      getUserDetails();
    }
    setNewRelative({
      name: "",
      relation: "",
      dob: "",
      ma: "",
      address: "",
      pin: "",
      phone: "",
      gender: "",
    });
    setShowRelatives(true);
  };

  const deleteRelative = async (id) => {
    try {
      await client.get(`/delete-relative`, {
        params: {
          oper: "del",
          id: id,
        },
      });

      getUserDetails();
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  const editRelative = async (id, newRelation) => {
    try {
      await client.get(`/edit-relative`, {
        params: {
          oper: "edit",
          id: id,
          relationName: newRelation,
        },
      });

      getUserDetails();
      setEditingId(null);
      setEditingRelation("");
    } catch (err) {
      console.error("Edit failed:", err);
    }
  };

  const handleEditClick = (id, currentRelation) => {
    setEditingId(id);
    setEditingRelation(currentRelation);
  };

  const handleSaveEdit = () => {
    if (editingRelation.trim()) {
      editRelative(editingId, editingRelation);
    }
  };

  const handleCancelEdit = () => {
    setEditingId(null);
    setEditingRelation("");
  };

  return (
    <div className={style.wrapper}>
      <h2 className={style.heading}>Join Family</h2>

      {/* Profile Fields */}
      <div className={style.grid}>
        <div className={style.field}>
          <label>Your Name</label>
          <input type="text" value={userData?.name || ""} readOnly />
        </div>
        <div className={style.field}>
          <label>Your Date of Birth</label>
          <input type="date" value={userData?.dob ? moment(userData?.dob, "DD-MM-YYYY").format("YYYY-MM-DD") : ""} />
        </div>
        <div className={style.field}>
          <label>Your Contact Number</label>
          <input type="text" value={userData?.number || ""} readOnly />
        </div>
        <div className={style.field}>
          <label>Spouse Name</label>
          <input type="text" placeholder="Spouse Name" />
        </div>
        <div className={style.field}>
          <label>Spouse Date of Birth</label>
          <input type="date" />
        </div>
        <div className={style.field}>
          <label>Spouse Number</label>
          <input type="text" placeholder="Phone Number" />
        </div>
        <div className={style.field}>
          <label>Marriage Anniversary</label>
          <input type="date" placeholder="Marriage Anniversary" value={userData?.marriageAnniversary ? moment(userData?.marriageAnniversary, "DD-MM-YYYY").format("YYYY-MM-DD") : ""} />
        </div>
      </div>

      {/* Relatives Section */}
      <div className={style.relativesSection}>
        <h3 className={style.subheading}>Relatives</h3>

        {userData.relatives?.map((rel) => (
          <div key={rel.ind1_ICSID} className={style.relativeCard}>
            <div className={style.relativeRow}>
              <input type="text" value={rel.ind1_name} readOnly />
              {editingId === rel.id ? (
                <input
                  type="text"
                  value={editingRelation}
                  onChange={(e) => setEditingRelation(e.target.value)}
                  placeholder="Edit relation"
                />
              ) : (
                <input type="text" value={rel.relation} readOnly />
              )}
              <input type="text" value={rel.ind1_dob} readOnly />
              <input type="text" value={rel.ind1_ma} readOnly />
            </div>

            <div className={style.relativeRow}>
              <input type="text" value={rel.ind1_address?.line1} readOnly />
              <input type="text" value={rel.ind1_address?.pincode} readOnly />
              <input type="text" value={rel.ind1_phone} readOnly />
              <input type="text" value={rel.ind1_gender} readOnly />
              <button
                className={style.deleteBtn}
                onClick={() => deleteRelative(rel.id)}
              >
                Delete
              </button>
              {editingId === rel.id ? (
                <>
                  <button
                    className={style.deleteBtn}
                    onClick={handleSaveEdit}
                  >
                    Save
                  </button>
                  <button
                    className={style.deleteBtn}
                    onClick={handleCancelEdit}
                  >
                    Cancel
                  </button>
                </>
              ) : (
                <button
                  className={style.editBtn}
                  onClick={() => handleEditClick(rel.id, rel.relation)}
                >
                  Edit
                </button>
              )}
            </div>
          </div>
        ))}

        {/* Add New Relative */}
        <div className={style.relativeCard}>
          <div className={style.relativeRow}>
            <input
              type="text"
              name="name"
              placeholder="Name of the relative"
              value={newRelative.name}
              onChange={handleChange}
            />
            <select name="relation" className="relativeCard mb-3" value={newRelative.relation} onChange={handleChange} >
            <option value="">Select Relation</option>
            <option value="brother">Brother</option>
            <option value="sister">Sister</option>
            <option value="relative">Relative</option>
            </select>
            <input
              type="date"
              name="dob"
              value={newRelative.dob}
              onChange={handleChange}
            />
             <input
              type="date"
              name="ma"
              value={newRelative.ma}
              onChange={handleChange}
            />
          </div>
          <div className={style.relativeRow}>
            <input
              type="text"
              name="address"
              placeholder="Address"
              value={newRelative.address}
              onChange={handleChange}
            />
            <input
              type="number"
              name="pin"
              placeholder="PIN"
              value={newRelative.pin}
              onChange={handleChange}
            />
            <select
              name="gender"
              value={newRelative.gender}
              onChange={handleChange}
              placeholder="Gender of the relative"
              className="relativeCard mb-3"
            > 
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
            </select>
            <input
              type="text"
              name="phone"
              placeholder="Relative Phone Number"
              value={newRelative.phone}
              onChange={handleChange}
            />
            <button className={style.addBtn} onClick={handleAddRelative}>
              Add
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoinFamily;